module.exports = __webpack_public_path__ + "img/q_next_btn.f9ffc815.png";